<template>
  <div class="date-header">{{ $moment($moment().format('YYYY') + '-' + month + '-01', 'YYYY-M-DD').lang($store.state.locale).format('MMMM') }} {{ year }}</div>
</template>

<script>
export default {
  name: 'DateHeader',
  props: {
    month: [String, Number],
    year: [String, Number],
  },
}
</script>
<style lang="scss" scoped>
.date-header {
  opacity: 0.8;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  color: var(--title-color);
  text-transform: uppercase;
  margin-bottom: 25px;
  position: relative;

  &::after {
    content: '';
    width: calc(100% - 168px);
    opacity: 0.1;
    height: 5px;
    background-color: #858585;
    right: 0;
    position: absolute;
    top: calc(50% - 3px);
  }
}
</style>